module.exports = __webpack_public_path__ + "img/logo_crediflores.9702426.png";